import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DevelopmentAPI } from "pages/workspace/process/development/development.service";
const initialState = {
  data: [],
  state: ""
};
export const releaseSlice = createSlice({
  name: "releases",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getReleases.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getReleases.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getReleases = createAsyncThunk('sprints/get', async({ query, workspaceId }) => {
  let data = await DevelopmentAPI.getRelease(query, workspaceId);
  return data['releases'];

});


export default releaseSlice.reducer;